/**
 * ★ THE ONE PLACE THE COLOUR SCHEME IS CHOSEN ★
 * =============================================
 *
 * Change `ACTIVE` below and the entire application re-skins — surfaces, text,
 * borders, Chakra colour scales, component styles and global CSS all follow.
 * No screen, component or module needs editing.
 *
 *     ACTIVE = 'apple-dark'   → Apple system blacks   (current)
 *     ACTIVE = 'navy'         → the previous navy scheme (rollback)
 *
 * ── To add a new scheme ─────────────────────────────────────────────────────
 *   1. Copy `navy.js`, rename it, change the values — keep every key.
 *      (`_contract.js` documents the required shape; the build fails if a slot
 *      is missing or the elevation ramp is inverted.)
 *   2. Register it in PRESETS below.
 *   3. `node scripts/theme/contrast-check.js` — must pass WCAG AA.
 *   4. Point ACTIVE at it.
 */

import navy from './navy';
import appleDark from './apple-dark';
import { validatePreset } from './_contract';

export const PRESETS = {
	navy,
	'apple-dark': appleDark,
};

/** ← CHANGE THIS LINE TO RE-SKIN THE APP. */
export const ACTIVE = 'apple-dark';

const preset = PRESETS[ACTIVE];

if (!preset) {
	// Fail loudly at import time rather than rendering an unstyled app.
	throw new Error(
		`[theme] Unknown preset "${ACTIVE}". Available: ${Object.keys(PRESETS).join(', ')}`,
	);
}

// The header above promises the build fails on a malformed preset. For a long
// time nothing actually called validatePreset — the promise was aspirational.
// This is the call that makes it true: a missing slot or inverted elevation
// ramp in the ACTIVE preset now throws at import time.
const problems = validatePreset(preset);
if (problems.length) {
	throw new Error(
		`[theme] Preset "${ACTIVE}" violates the contract:\n  - ${problems.join('\n  - ')}`,
	);
}

export default preset;
